import { render, staticRenderFns } from "./publicmatch.vue?vue&type=template&id=11643822&scoped=true&"
import script from "./publicmatch.ts?vue&type=script&lang=ts&"
export * from "./publicmatch.ts?vue&type=script&lang=ts&"
import style0 from "./publicmatch.scss?vue&type=style&index=0&id=11643822&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11643822",
  null
  
)

export default component.exports